<template>
  <nav class="navbar-container px-container">
      <div class="navbar-logo-links">
        <div class="navbar-brand-container">
          <a href="/" class="navbar-logo">🌐</a>
          <a href="/" class="navbar-brand">NiceApp</a>
        </div>



        <router-link to="/courses/1" class="nav-link nav-link-desktop ">
          <font-awesome-icon icon="user-plus" /> Java
        </router-link>

        <router-link to="/courses/10" class="nav-link nav-link-desktop ">
          <font-awesome-icon icon="user-plus" /> FillModule
        </router-link>

        <router-link to="/courses/2" class="nav-link nav-link-desktop ">
          <font-awesome-icon icon="user-plus" /> Книги
        </router-link>

        <router-link to="/prompt" class="nav-link nav-link-desktop ml-20">
          <font-awesome-icon icon="user-plus" /> 🦾 Prompt
        </router-link>
      </div>

      <div v-if="!currentUser" class="navbar-user hide-on-mobile">
        <a class="nav-link">
          <router-link to="/register" class="nav-link">
            <font-awesome-icon icon="user-plus" /> Sign Up
          </router-link>
        </a>
      </div>

      <div v-if="currentUser" class="navbar-user hide-on-mobile">
        <div class="user-menu-container">
          <button class="user-button" @click="toggleUserMenu">
            <span class="user-icon">🧑🏻‍💻</span>
            <span class="username">{{ currentUser.username }}</span>
          </button>
          <div class="user-dropdown" v-if="isUserMenuOpen">
            <router-link to="/profile" class="dropdown-item">
              <span class="item-icon">🧑🏻‍💻</span>
              Profile
            </router-link>
            <div class="dropdown-divider"></div>
            <a @click="logOut" class="dropdown-item">
              <span class="item-icon">🚪</span>
              Logout
            </a>
          </div>
        </div>
      </div>

      <div class="burger-icon" @click="$emit('toggleMenu')">
        <span :class="{ 'open-top': isOpen }"></span>
        <span :class="{ 'open-middle': isOpen }"></span>
        <span :class="{ 'open-bottom': isOpen }"></span>
      </div>
  </nav>
</template>

<script>

export default {
  props: {
    isOpen: Boolean,
  },
  data() {
    return {
      isUserMenuOpen: false
    }
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
      this.isUserMenuOpen = false;
      this.$emit('toggleMenu');
    },
    toggleUserMenu() {
      this.isUserMenuOpen = !this.isUserMenuOpen;
    },
    closeUserMenu(e) {
      if (!e.target.closest('.user-menu-container')) {
        this.isUserMenuOpen = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.closeUserMenu);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.closeUserMenu);
  },
};
</script>

<style>
/* Глобальные стили для корректной работы с модальным окном */
:root {
  --scrollbar-width: 0px;
}

body.modal-open {
  --scrollbar-width: 17px;
}
</style>

<style scoped>
.navbar-container {
  height: var(--header-height);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(31, 31, 31, 0.95);
  backdrop-filter: blur(10px);
  position: fixed;
  z-index: 1001;
  top: 0;
  left: 0;
  right: 0;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
}

.navbar-logo-links {
  display: flex;
  align-items: center;
  gap: var(--space-element);
}

.navbar-logo {
  font-weight: 600;
  font-size: 22px;
  padding: 5px 7px;
  margin-right: 10px;
  background: rgba(255, 255, 255, 0.1);
  text-align: center;
  border-radius: 10px;
  text-decoration: none;
  transition: all 0.3s ease;
}

.navbar-brand-container:hover .navbar-logo {
  background-color: var(--my-links);
}

.navbar-brand {
  font-weight: 500;
  font-size: 24px;
  color: var(--my-light);
  margin-right: var(--space-inner);
}


.navbar-user {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.nav-link {
  color: var(--my-white);
  opacity: 0.8;
  padding: 3px 5px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.nav-link:hover {
  color: var(--my-white);
  opacity: 1;
  background: rgba(255, 255, 255, 0.1);
}


.burger-icon {
  width: 25px;
  height: 18px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  z-index: 2000;
  margin-left: auto;
  margin-right: 5px;
}

.burger-icon span {
  display: block;
  width: 100%;
  height: 2px;
  background-color: var(--my-white);
  border-radius: 0.6px;
  transition: all 0.8s ease;

}

.burger-icon:hover span {
  background-color: gray;
}
.open-top {
  transform: rotate(45deg) translate(5px, 4px);
  background-color: white;
  top: 0;
  right: 0;
  z-index: 1005 !important;

}

.open-bottom {
  transform: rotate(-45deg) translate(7px, -6px);
  cursor: pointer !important;
  z-index: 2000 !important;
  background-color: gray;
}

.open-middle {
  opacity: 0;
}












@media (max-width: 768px) {

  .navbar {
    justify-content: flex-start;
  }




  .navbar-logo {
    font-size: 17px;
    background-color: #373C4B;
    padding: 7px 9px;
    text-align: center;
    border-radius: 7px;
  }

  .navbar-brand {
    font-weight: 500;
    font-size: 18px;
  }

  .nav-link-desktop {
    display: none;
  }

}


@media (min-width: 768px) {


  .burger-icon {
    position: fixed;
    top: 17px;
    right: 14px;
    width: 25px;
    height: 20px;
    cursor: pointer;
    z-index: 1003;
    display: none;
    flex-direction: column;
    justify-content: space-between;
  }

  .burger-icon span {
    display: none;
    width: 100%;
    height: 3px;
    background-color: var(--my-white);
    border-radius: 0.6px;
    transition: all 0.8s ease;
  }

  .burger-icon:hover span {
    background-color: gray;
  }
}

















.burger-background {
  height: 100%; /* Высота во всю высоту nav */
  width: 60px;
  right: 0; /* Зафиксировать его справа */
  top: 0; /* Стартовать сверху */
  background-color: #151824;


}

.user-menu-container {
  position: relative;
  display: flex;
  align-items: center;
}

.user-button {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.1);
  border: none;
  padding: 6px 12px;
  border-radius: 8px;
  color: var(--my-white);
  cursor: pointer;
  transition: all 0.3s ease;
  margin-right: var(--scrollbar-width, 0);
}

.user-button:hover {
  background: rgba(255, 255, 255, 0.15);
}

.user-icon {
  font-size: 18px;
}

.username {
  font-size: 14px;
  font-weight: 500;
}

.user-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 180px;
  background: rgba(31, 31, 31, 0.98);
  backdrop-filter: blur(10px);
  border-radius: 8px;
  padding: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  color: var(--my-white);
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.2s ease;
  cursor: pointer;
  opacity: 0.8;
}

.dropdown-item:hover {
  background: rgba(255, 255, 255, 0.1);
  opacity: 1;
}

.item-icon {
  font-size: 16px;
}

.dropdown-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 4px 0;
}

@media (max-width: 768px) {
  .user-button {
    padding: 6px;
  }

  .username {
    display: none;
  }
}

</style>





